import * as React from 'react';
const SvgVolume = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.105 10.003H1a1 1 0 01-1-1v-2a1 1 0 011-1h2.105l4.05-3.848A.5.5 0 018 2.517v10.971a.5.5 0 01-.844.363l-4.05-3.848zm10.667 3.539a1 1 0 01-1.443-1.385A5.976 5.976 0 0014 8.003a5.975 5.975 0 00-1.674-4.158 1 1 0 011.441-1.386A7.975 7.975 0 0116 8.003c0 2.092-.808 4.06-2.228 5.539zm-4.004-2.357a1 1 0 001.414 0A4.488 4.488 0 0012.5 8.003c0-1.21-.48-2.345-1.318-3.182a1 1 0 10-1.414 1.414c.466.466.732 1.095.732 1.768s-.266 1.301-.732 1.768a1 1 0 000 1.414z"
            fill="currentColor"
        />
    </svg>
);
export default SvgVolume;
